import { React, ui } from '_core';

type ETFFieldProps = {
  value?: string | string[];
  setValue: (_d: string | string[]) => void;
  multiple?: boolean;
};

const ETFField = ({ value = '', setValue, multiple = false }: ETFFieldProps) => (
  <ui.ETFSelector
    value={value}
    setValue={(val) => {
      setValue(val);
    }}
    multiple={multiple}
  />
);

export default ETFField;
